import Enum from "../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../constants";

export const documentTemplateSchema = {
    "documentTemplateFolder": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "order": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentTemplate": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "form": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "serverForm": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentTemplateStatus",
            value: Enum.BE_DOCUMENT_TEMPLATE_STATUS.NONE,
        },
        "state": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentTemplateState",
            value: Enum.BE_DOCUMENT_TEMPLATE_STATE.ACTIVE,
        },
        "enabledDraftEdit": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "statusDate.deletedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        // BE 조립분 — admin saga Assembler 만 얹는다. member·dept-head 응답에는 없다
        "lastModifiedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        // BE 조립분 — aggregate 필드가 아니라 Assembler 가 MemberContext(현재 멤버) 기준으로
        // 얹는다. 그래서 member saga 응답에만 있고 admin·dept-head 에는 없다
        // (관리자에게는 즐겨찾기 주체가 없다). 역할별 omit 은 serializer 참조
        "favorite": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        }
    },

    "documentTemplateHistory": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "action": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentTemplateHistoryAction",
            value: null,
        },
        "source": {
            type: DATA_TYPE.ENUM,
            enum: "HistorySource",
            value: null,
        },
        "actorId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "actorName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "documentTemplateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "userAgent": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.USER_AGENT,
            value: "",
        },
        "ip": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.IP,
            value: "",
        },
        "reason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "changes": {
            type: DATA_TYPE.ARRAY,
            value: [],
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
    },

    "documentTemplateHistoryDetail": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "action": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentTemplateHistoryAction",
            value: null,
        },
        "changes": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "field": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "target": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "before": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "after": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
    },

    "documentTemplateFolderCounts": {
        "allCount": {
            type: DATA_TYPE.NUMBER,
            value: 0,
        },
        "counts": {
            type: DATA_TYPE.DATA,
            value: {},
        },
    }
} as const;
